export default __webpack_public_path__ + "static/media/Scope-8.a67dde00.png";